/* eslint-disable no-underscore-dangle */
import { createAction } from '@reduxjs/toolkit';
import type { SoftwareState } from '../reducers/software';
import type { AppThunk } from '../store/configureStore';
import { showAPIError } from './api-error';

type Softwares = SoftwareState['softwares'];

export const CLEAR_SOFTWARES = createAction<void>('CLEAR_SOFTWARES');
export const GET_SOFTWARES = createAction<Softwares>('GET_SOFTWARES');
export const GET_SOFTWARE_PRODUCT_CODES = createAction<string[]>('GET_SOFTWARE_PRODUCT_CODES');
export const GET_SOFTWARE_TARGET_HARDWARES = createAction<string[]>(
  'GET_SOFTWARE_TARGET_HARDWARES'
);
export const CREATE_SOFTWARE = createAction<void>('CREATE_SOFTWARE');
export const DELETE_SOFTWARE = createAction<void>('DELETE_SOFTWARE');

export const createSoftware =
  (postData: Record<string, unknown> = {}): AppThunk =>
  async (dispatch) => {
    const response = await fetch('/api/softwares', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
      },
      // eslint-disable-next-line no-underscore-dangle
      body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...postData }),
    });
    if (!response.ok) {
      dispatch(showAPIError(await response.json()));
      return;
    }
    await response.json();
    dispatch(CREATE_SOFTWARE());
  };

export const getSoftwares =
  (query = ''): AppThunk =>
  async (dispatch) => {
    const response = await fetch(`/api/softwares?${query}`);
    if (!response.ok) {
      dispatch(showAPIError(await response.json()));
      return;
    }
    dispatch(GET_SOFTWARES(await response.json()));
  };

export const getSoftwareProductCodes = (): AppThunk => async (dispatch) => {
  const response = await fetch('/api/softwares/product-codes');
  if (!response.ok) {
    dispatch(showAPIError(await response.json()));
    return;
  }
  const { product_codes: productCodes } = await response.json();
  dispatch(GET_SOFTWARE_PRODUCT_CODES(productCodes));
};

export const getSoftwareTargetHardwares =
  (product_code: string): AppThunk =>
  async (dispatch) => {
    const response = await fetch(`/api/softwares/product-codes/${product_code}/target-hardwares`);
    if (!response.ok) {
      dispatch(showAPIError(await response.json()));
      return;
    }
    const { target_hardwares: targetHardwares } = await response.json();
    dispatch(GET_SOFTWARE_TARGET_HARDWARES(targetHardwares));
  };

export const deleteSoftware =
  (id: string): AppThunk =>
  async (dispatch) => {
    const response = await fetch(`/api/softwares/${id}`, {
      method: 'DELETE',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ _csrf_token: (window as any)._csrf_token }),
    });
    if (!response.ok) {
      dispatch(showAPIError(await response.json()));
      return;
    }
    dispatch(DELETE_SOFTWARE());
  };

export const clearSoftwares = (): AppThunk => async (dispatch) => dispatch(CLEAR_SOFTWARES());
